import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { map, Subject } from 'rxjs';
import { IGenericType } from '@library/common/generictype';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {

  private url = 'search/document';

  refresh$: Subject<void> = new Subject();

  constructor(
    private cache: CacheService
  ) { }

  searchDocument( id: string ) {
    return this.cache.request({
      url: `${ this.url }?id=${ id }`,
      refresher: this.refresh$,
      useLambda: true,
    })
    .pipe(
      map(( v: IGenericType ) => v.response.collection[ 0 ] ),
    );
  }

}
